import CollectionCard from "Component/Collection/CollectionCard";
import Footer from "Component/Footer/Footer";
import Header from "Component/Header/Header";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Col, Container, FormGroup, Input, Row } from "reactstrap";
import { allsellItemFromCollectionId, getItemsById, getNewCollectionByEmailStart } from "store/actions";
import { Oval } from 'react-loader-spinner'
export default function CollectionView(props) {
// const params = useSelector((state) => state)
const [museumdata, setMuseumData] = useState({})
  // const navigate = useNavigate()
  const {id} = useParams()
  const location = useLocation()
  const getEmail = useSelector((state) => state?.Login.user.email);
  const dispatch = useDispatch(getEmail)
  const [email, setEmail] = useState()
  const [collectionByEmail, setCollectionByEmail] = useState([])
  const [collectionBySearch, setCollectionBySearch] = useState([])
  const [search, setSearch] = useState('')
  const { loading } = useSelector((state) => state?.collections);
  const [collectionId, setCollectionId] = useState('')
  const backto = () => {
    window.history.back()
  }
  useEffect(()=>{

  }, [id])

  useEffect(()=> {
    setMuseumData(location.state.data)
    setCollectionId(location?.state?.data?.collection[0]?._id)
    
  }, [location.state])
  useEffect(() => {
    const callback = (res) => {
      if (res.status === "success") {
        setCollectionBySearch(res.data)
        setCollectionByEmail(res.data)
      }
    }
    let data = {}
    data.email = museumdata.email
    dispatch(getNewCollectionByEmailStart(data, callback));
  }, [museumdata]);

  const handleSearch = (e) => {
    const value = e
    setSearch(e)
  }
  useEffect(() => {
    if (search === '') {
      setCollectionBySearch(collectionByEmail)
    } else {
      setCollectionBySearch(collectionByEmail?.filter((item) => { return search === '' ? item : item?.name.toLowerCase().includes(search.toLowerCase()) }))
    }
  }, [search])


  useEffect(() => {
    let data = {}
    data.collection_id = collectionId
    dispatch(allsellItemFromCollectionId(data))
  }, [id])
  return (
    <>
    {loading &&
      <div className='loaderBoxMiane'>
        <Oval
          height={80}
          width={80}
          color="#6C63FF"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
          ariaLabel='oval-loading'
          secondaryColor="#6C63FF"
          strokeWidth={2}
          strokeWidthSecondary={2}
        />
      </div>
    }
      <Header />
      <div className="container-fluid profileBox nftview">
        <Row>
          <Col lg={12}>
            <h1><div className="d-inline cursor-pointer" onClick={backto}>MUSEUMS</div> / <span> {museumdata?.museumName}</span> </h1>
          </Col>
        </Row>
      </div>
      <Container>
        <Row className="pb-5">
          <Col lg={12}>
            <div className="collectionProfile mt-4">
              <div className="profileBoXIn pb-4">
                <div className="profileImgbx">
                  {/* <img src={collection.image?.link} alt="" /> */}
                  <img src= {museumdata?.profileImage?.link} alt="" />
                  {/* "/images/png/digitalartimg3.png" */}
                </div>
              </div>
              <div className="profileCollection">
                {/* <button className="editColelction btn btn-outline-dark px-4"><i className="fa-regular fa-pen-line"></i> Edit Collection</button> */}
                <div className="profilecollCont">
                  <h1>{museumdata?.museumName}</h1>
                  {/* <p>@thezairastanton</p> */}

                </div>
                {/* <button className="addnft btn btn-outline-dark px-4"><i className="fa-regular fa-pen-line"></i> Add  NFT’s</button> */}
              </div>
              <p className="profileTextCollView">
              {museumdata?.description}
              </p>
            </div>
            <Row className="justify-content-between searchcoll">
              <Col lg={6}>
                <div className="position-relative ">
                  <Input
                    className="form-control searchInput"
                    placeholder="Search for collections"
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <button className="btn position-absolute end-0 top-0 bottom-0 my-auto border-0">
                    <i className="fa-light fa-magnifying-glass"></i>
                  </button>
                </div>
                <p className="pdecription pdecriptioncol text-start">Showing {collectionBySearch ? collectionBySearch.length : 0} Collections</p>
              </Col>
              <Col lg={4}>
                <div className="d-flex align-item-center gap-3">
                  <Input
                    type="select"
                    className="form-control searchInput shadow-none"
                  >
                    <option>Low to High </option>
                    <option>High to Low</option>
                  </Input>
                  <Input
                    type="select"
                    className="form-control searchInput shadow-none"
                  >
                    <option>DAILY</option>
                    <option>WEEKLY</option>
                  </Input>
                  <button className="btn border-0 clearfilter p-0">
                    <i className="fa-solid fa-filter-circle-xmark"></i>
                  </button>
                </div>
              </Col>
            </Row>

            <Row>
              {/* {collectionBySearch.map((item, index) =>
                <Col className="mb-3" lg={3}>
                  <div className="artItemBoxNew nftBox">
                    <div className="imgBox">
                      <img src="/images/png/digitalartimg3.png" alt="" />
                    </div>
                    <div className="contBox mt-3">
                      <div className="arthead mb-2">
                        <h2 className="productName">{item?.name}</2>
                     <h2 className="productPrice">$ 2.5</h2> *
                      </div>
                      <p>
                        {item?.description}
                      </p>
                      <div className="viewAndLike">
                        <p>
                          <i className="fa-regular fa-eye"></i>
                          <span>Total NFT's</span>
                          {item?.totalNfts}
                        </p>
                        {* <p>
                          <i className="fa-regular fa-heart"></i>
                          <span>Likes</span>
                          70,890
                        </p> *}
                      </div>
                    </div>
                  </div>
                </Col>
              )} */}
              {collectionBySearch.map((item, index) =>
              <Col className="mb-3" key={index} lg={3}>
                <CollectionCard data={item} />
              </Col>
              )}
              {/* <Col className="mb-3" lg={3}>
                  <Link className="text-decoration-none" to={'/nfts'}>
                  <div className="artItemBoxNew nftBox">
                    <div className="imgBox">
                      <img src="/images/png/digitalartimg3.png" alt="" />
                    </div>
                    <div className="contBox mt-3">
                      <div className="arthead mb-2">
                        <h2 className="productName">Kaylynn Franci</h2>
                    
                      </div>
                      <p>
                      Origin Story is partnered with top collections such as
                      Pudgy Penguins, Karafuru, Moonrunners, Sappy Seals,
                      OnChainMonkeys, 0N1 Force, and others.
                      </p>
                      <div className="viewAndLike">
                        <p>
                          <i className="fa-regular fa-eye"></i>
                          <span>Total NFT's</span>
                          6
                        </p>
                       
                      </div>
                    </div>
                  </div>
                  </Link>
                </Col> */}
              {/* <Col className="mb-3" lg={3}>
                <div className="artItemBoxNew nftBox">
                  <div className="imgBox">
                    <img src="/images/png/digitalartimg3.png" alt="" />
                  </div>
                  <div className="contBox mt-3">
                    <div className="arthead mb-2">
                      <h2 className="productName">Kaylynn Franci</h2>
                      <h2 className="productPrice">$ 2.5</h2>
                    </div>
                    <p>
                      Origin Story is partnered with top collections such as
                      Pudgy Penguins, Karafuru, Moonrunners, Sappy Seals,
                      OnChainMonkeys, 0N1 Force, and others.
                    </p>
                    <div className="viewAndLike">
                      <p>
                        <i className="fa-regular fa-eye"></i>
                        <span>Views</span>
                        91,177
                      </p>
                      <p>
                        <i className="fa-regular fa-heart"></i>
                        <span>Likes</span>
                        70,890
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col className="mb-3" lg={3}>
                <div className="artItemBoxNew nftBox">
                  <div className="imgBox">
                    <img src="/images/png/digitalartimg3.png" alt="" />
                  </div>
                  <div className="contBox mt-3">
                    <div className="arthead mb-2">
                      <h2 className="productName">Kaylynn Franci</h2>
                      <h2 className="productPrice">$ 2.5</h2>
                    </div>
                    <p>
                      Origin Story is partnered with top collections such as
                      Pudgy Penguins, Karafuru, Moonrunners, Sappy Seals,
                      OnChainMonkeys, 0N1 Force, and others.
                    </p>
                    <div className="viewAndLike">
                      <p>
                        <i className="fa-regular fa-eye"></i>
                        <span>Views</span>
                        91,177
                      </p>
                      <p>
                        <i className="fa-regular fa-heart"></i>
                        <span>Likes</span>
                        70,890
                      </p>
                    </div>
                  </div>
                </div>
              </Col> */}
            </Row>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}
